/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "booking",
            "endpoint": "https://0awqs7f4nb.execute-api.eu-west-1.amazonaws.com/main",
            "region": "eu-west-1"
        },
        {
            "name": "cerfa",
            "endpoint": "https://6shaw8r323.execute-api.eu-west-1.amazonaws.com/main",
            "region": "eu-west-1"
        },
        {
            "name": "documents",
            "endpoint": "https://ehwhrf70gh.execute-api.eu-west-1.amazonaws.com/main",
            "region": "eu-west-1"
        },
        {
            "name": "email",
            "endpoint": "https://dobuslkfe3.execute-api.eu-west-1.amazonaws.com/main",
            "region": "eu-west-1"
        },
        {
            "name": "fhir",
            "endpoint": "https://jhnknpq0ma.execute-api.eu-west-1.amazonaws.com/main",
            "region": "eu-west-1"
        },
        {
            "name": "payment",
            "endpoint": "https://vofztrd187.execute-api.eu-west-1.amazonaws.com/main",
            "region": "eu-west-1"
        },
        {
            "name": "twilio",
            "endpoint": "https://7i62x3rbsf.execute-api.eu-west-1.amazonaws.com/main",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:f045fda6-91bb-4501-ad61-c4a71387e2c1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_GvHNcHd7v",
    "aws_user_pools_web_client_id": "3sgk7uptp3lmls5h04gv4m3r27",
    "oauth": {
        "domain": "medeo-prod.auth.eu-west-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
